import css from './Warning.css';

export class Warning {
    constructor() {
        this._container = document.createElement('section');
        this._container.className = css.container;

        this._header = document.createElement('header');
        this._header.className = css.header;
        this._header.innerHTML = 'Warning:';
        this._container.appendChild(this._header);

        this._content = document.createElement('main');
        this._content.className = css.content;
        this._content.innerHTML = 'Meow overload!';
        this._container.appendChild(this._content);

        document.body.appendChild(this._container);
    };

    activate() {
        this._container.className += ' ' + css["container--visible"];
    }

    setMediumSeverity() {
        this._content.innerHTML = 'It is getting meowt offf control!!!';
    }

    setMaxSeverity() {
        this._content.innerHTML = 'Meow Meow Meow Meow Mewooeowoew!!!';
    }

    deactivate() {
        //
    }
}